import { Component, Injector, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ApAlertService } from 'webcommon/core-ui';
import { FcUrgencyListItemDto, FcModifyUrgencyTypeListItemDto } from 'webcommon/shared';

import {
  FcGenericItemModalBaseComponent,
  FcListValidationService,
} from '../../generic/index';

@Component({
  providers: [ApAlertService, FcListValidationService],
  selector: 'fc-urgency-list-modal',
  templateUrl: './fc-urgency-list-modal.component.html',
})
export class FcUrgencyListModalComponent extends FcGenericItemModalBaseComponent implements OnInit {
  public override baseId = 'fc-urgency-type';

  // List Item with default value
  public listItem: FcUrgencyListItemDto;

  // Form Controls
  public externalIdControl: FormControl = new FormControl('');
  public nameControl: FormControl = new FormControl('');
  public notesControl: FormControl = new FormControl('');
  public inactiveControl: FormControl = new FormControl(false);
  public userDefinedControl: FormControl = new FormControl(true);
  public urgency: FormControl = new FormControl('');
  public isDefault: FormControl = new FormControl(false);

  // Form Group
  public form = new FormGroup({
    externalId: this.externalIdControl,
    name: this.nameControl,
    notes: this.notesControl,
    inactive: this.inactiveControl,
    userDefined: this.userDefinedControl,
    urgency: this.urgency,
    IsDefault: this.isDefault
  });

  constructor(injector: Injector) {
    super(injector);
  }

  override ngOnInit() {
    super.ngOnInit();

    // Load List Item and set default validation rules
    this.loadListItem({
      ExternalID: {
        MaxLength: 25,
      },
      Name: {
        IsRequired: true,
        MaxLength: 50,
      },
      Notes: {
        MaxLength: 65535,
      },
    });
  }

  public setForm(): void {
    const userDefinedValue = this.listItem?.UserDefined ?? true;
    // External ID Control
    this.externalIdControl.setValidators(this.fcListValidation.getValidators('ExternalID'));
    this.externalIdControl.setValue(this.listItem?.ExternalID);

    // Name Control
    const isNameControlDisabled = !userDefinedValue;
    if (isNameControlDisabled) {
      this.nameControl.disable();
    }
    this.nameControl.setValidators(this.fcListValidation.getValidators('Name'));
    this.nameControl.setValue(this.listItem?.Name);

    // Notes Control
    this.notesControl.setValidators(this.fcListValidation.getValidators('Notes'));
    this.notesControl.setValue(this.listItem?.Notes);

    // Inactive Control
    this.inactiveControl.setValue(this.listItem?.Inactive || false);

    // User Defined Control
    this.userDefinedControl.disable();
    this.userDefinedControl.setValue(userDefinedValue);

    this.urgency.setValue(this.listItem?.Urgency?this.listItem?.Urgency:'2');

    this.isDefault.setValue(this.listItem?.IsDefault || false);

    this.validateForm();
  }

  public override save(): void {
    const values = this.form.getRawValue();
    const modifyItemDto: FcModifyUrgencyTypeListItemDto = {
      ExternalID: values.externalId,
      Name: values.name,
      Inactive: values.inactive,
      Notes: values.notes,
      UserDefined: values.userDefined,
      Urgency: parseInt(values.urgency, 10),
      IsDefault: values.IsDefault
    };
    super.save<FcModifyUrgencyTypeListItemDto>(modifyItemDto);
  }
}
